import { useSyncExternalStore } from "react";

/*
 * Where the "Print now" button lives: in the hero while the hero's buttons are on screen, in the
 * navbar once they have scrolled away (and on every other page). Both places read this one flag,
 * so they flip in the same render and framer-motion can animate the button between them.
 */

const ANCHOR = "[data-cta-anchor]";
let inNav = typeof window === "undefined" ? true : window.location.pathname !== "/" || window.scrollY > 300;
const listeners = new Set();
let raf = 0;

function compute() {
  raf = 0;
  const el = document.querySelector(ANCHOR);
  const next = el ? el.getBoundingClientRect().bottom < 84 : true;
  if (next === inNav) return;
  inNav = next;
  listeners.forEach((fn) => fn());
}

/** Re-checks on the next frame (scroll, resize, route change). */
export function measureCta() {
  if (typeof window === "undefined" || raf) return;
  raf = requestAnimationFrame(compute);
}

function subscribe(fn) {
  listeners.add(fn);
  if (listeners.size === 1) {
    window.addEventListener("scroll", measureCta, { passive: true });
    window.addEventListener("resize", measureCta);
  }
  measureCta();
  return () => {
    listeners.delete(fn);
    if (listeners.size === 0) {
      window.removeEventListener("scroll", measureCta);
      window.removeEventListener("resize", measureCta);
    }
  };
}

const get = () => inNav;
const getServer = () => true;

/** True when the Print now button should sit in the navbar. */
export function useCtaInNav() {
  return useSyncExternalStore(subscribe, get, getServer);
}

export const CTA_LAYOUT_ID = "print-now-cta";
export const CTA_TRANSITION = { layout: { type: "spring", stiffness: 210, damping: 28, mass: 0.9 } };
